import * as docx from "docx";
import { saveAs } from "file-saver";
import getHotelCardForm from "./Template/getHotelCardForm";
import getPlaneTicketForm from "./Template/getPlaneTicketForm";
import getTravelPaperForm from "./Template/getTravelPaperForm";
import UseVehicleForm from "./Template/getVehicleForm";
import getVehicleLicenseForParner from "./Template/getVehicleLicenseForParner";
import getVelicleLicense from "./Template/getVelicleLicense";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import getExportTicketForm from "./Template/getExportTicketForm";
import { useEmployee } from "../../../../../hook";
// import { Viewer } from "react-file-viewer";

const useExportDocxFile = ({ item, docType, isViags = true }: { item: any; docType: number; isViags?: boolean}) => {

  const {getEmployeesByEmail, data} = useEmployee();

  const exportUseVehicleForm = (item: any, isReroute?: boolean) => {
    const isLongTerm = item?.eStage === "longTerm"
    switch (docType) {
      case 1:
        const doc1 = item && data && UseVehicleForm(item, data);

        docx.Packer.toBlob(doc1).then((blob) => {
          saveAs(blob, `DeNghiXe_${getDDMMYYYFormat(new Date())}.docx`);
        });
        break;
      case 2:
        const doc2 = item && getPlaneTicketForm(item, isReroute || false, getEmployeesByEmail);

        docx.Packer.toBlob(doc2).then((blob) => {
          saveAs(blob,isReroute ? `YeuCauHoanVe_${getDDMMYYYFormat(new Date())}.docx` : `CapVeCongTac_${getDDMMYYYFormat(new Date())}.docx`);
        });
        break;
      case 3:
        const doc3 = getTravelPaperForm(item);

        docx.Packer.toBlob(doc3).then((blob) => {
          saveAs(blob, `GiayDiDuong_${getDDMMYYYFormat(new Date())}.docx`);
        });
        break;
      case 31:
        const doc31 = getExportTicketForm(item, isViags);

        docx.Packer.toBlob(doc31).then((blob) => {
          saveAs(blob, `GiayYeuCau${!isViags ? 'Xuat' : 'Hoan'}Ve_${getDDMMYYYFormat(new Date())}.docx`);
        });
        break;
      case 4:
        const doc4 = getHotelCardForm(item, isViags);

        docx.Packer.toBlob(doc4).then((blob) => {
          saveAs(blob, `${isLongTerm ? "DH" : "NH"}_KSAN_${isViags ? `Viags_${getDDMMYYYFormat(new Date())}` : `DoiTac_${getDDMMYYYFormat(new Date())}`}.docx`);
        });
        break;
      case 5:
        const doc5 = getVelicleLicense(item);

        docx.Packer.toBlob(doc5).then((blob) => {
          saveAs(blob, `${isLongTerm ? "DH" : "NH"}_CapGiayPhepXe_Viags_${getDDMMYYYFormat(new Date())}.docx`);
        });
        break;
      case 6:
        const doc6 = getVehicleLicenseForParner(item);

        docx.Packer.toBlob(doc6).then((blob) => {
          saveAs(blob, `${isLongTerm ? "DH" : "NH"}_CapGPPhuongTien_DoiTacViags_${getDDMMYYYFormat(new Date())}.docx`);
        });
        break;
      default:
        docx.Packer.toBlob(doc1).then((blob) => {
          saveAs(blob, `P_GNVT_${getDDMMYYYFormat(new Date())}.docx`);
        });
        break;
    }
  };

  return {
    exportForm: exportUseVehicleForm,
  };
};

export default useExportDocxFile;
